export class DomService {
  static removeScriptsFromString(string: string) {
    const divElement = document.createElement("div");
    divElement.innerHTML = string;

    const scriptElements = divElement.getElementsByTagName("script");
    if (scriptElements) {
      for (const scriptElement of Array.from(scriptElements)) {
        scriptElement.remove();
      }
    }

    return divElement.innerHTML;
  }
}
